module.exports = __webpack_public_path__ + "static/media/favicon.c55fefe6.ico";